import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExitLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 16 16",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "e/icon/system/exit_line",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M8.00033 2C8.36853 2 8.66699 2.29848 8.66699 2.66667C8.66699 3.00855 8.40964 3.29034 8.07807 3.32885L8.00033 3.33333H4.66699C4.3251 3.33333 4.04332 3.5907 4.00481 3.92225L4.00033 4V12C4.00033 12.3419 4.25769 12.6237 4.58925 12.6622L4.66699 12.6667H7.66699C8.03519 12.6667 8.33366 12.9651 8.33366 13.3333C8.33366 13.6752 8.07631 13.957 7.74474 13.9955L7.66699 14H4.66699C3.60187 14 2.73122 13.1674 2.67039 12.1175L2.66699 12V4C2.66699 2.93488 3.49961 2.06423 4.54948 2.0034L4.66699 2H8.00033ZM11.805 5.64298L13.6907 7.5286C13.951 7.78893 13.951 8.21107 13.6907 8.4714L11.805 10.357C11.5447 10.6174 11.1226 10.6174 10.8622 10.357C10.6019 10.0967 10.6019 9.67453 10.8622 9.4142L11.6098 8.66667H8.00033C7.63213 8.66667 7.33366 8.3682 7.33366 8C7.33366 7.6318 7.63213 7.33333 8.00033 7.33333H11.6098L10.8622 6.58579C10.6019 6.32544 10.6019 5.90333 10.8622 5.64298C11.1226 5.38263 11.5447 5.38263 11.805 5.64298Z"
		})
	})
});
export default SvgExitLine;
